export default {
  BASE_URL: '/bid',
  api: [
    {
      name: 'list',
      method: 'GET',
      desc: '获取招标公告列表',
      path: '/homeList'
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '获取标书详情',
      path: '/detailInfo'
    },
    {
      name: 'units',
      method: 'GET',
      desc: '获取招标单位',
      path: '/bidUnits'
    },
    {
      name: 'status',
      method: 'GET',
      desc: '获取招标状态',
      path: '/status'
    },
    {
      name: 'comments',
      method: 'GET',
      desc: '招标答疑',
      path: '/askOrReply',
      param: {
        headId: 1,
        page: true
      }
    },
    {
      name: 'winList',
      method: 'GET',
      desc: '获取中标列表',
      path: '/winList'
    },
    {
      name: 'winDetail',
      method: 'GET',
      desc: '获取投标详情',
      path: '/winBidDetail'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/home/tender.js